import {
    RaikoBaseContainer, RaikoBreadcrumb, raikoBreadCrumbItemGenerator, RaikoButtonSecondary,
    RaikoFlexFirstChildGrowOne,
    RaikoGridOneColumn
} from "@moeindal/base-raiko-panel-components";
import {RouteHelper} from "../../route/RouteHelper";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useState} from "react";
import TabContext from "@mui/lab/TabContext";
import Box from "@mui/material/Box";
import TabList from "@mui/lab/TabList";
import Tab from "@mui/material/Tab";
import TabPanel from "@mui/lab/TabPanel";
import GamePeriodBasicInfo from "../../component/gamePeriod/gamePeriodBasicInfo/GamePeriodBasicInfo";
import {css} from "@emotion/css";
import GameRegistration from "../gameRegistration/GameRegistration";
import GameTeams from "../gameTeams/GameTeams";

export default function GamePeriodDetails() {


    const {state} = useLocation();
    const {gamePeriodId} = useParams()

    const [gamePeriodTitle, setGamePeriodTitle] = useState(state && state.title ? state.title : RouteHelper.GamePeriodDetails.name)

    const [tabSelectedValue, setTabSelectedValue] = useState(GamePeriodTabType.BasicInformation.id)

    function handleChangeTab(event, newValue) {
        setTabSelectedValue(newValue)
    }

    const navigate = useNavigate()


    return (
        <RaikoBaseContainer>
            <RaikoGridOneColumn>
                <RaikoFlexFirstChildGrowOne>
                    <RaikoBreadcrumb breadCrumbItems={[
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.Game.name,
                            ""
                        ),
                        raikoBreadCrumbItemGenerator(
                            RouteHelper.GamePeriod.name,
                            RouteHelper.GamePeriod.globalUrl
                        ),
                        raikoBreadCrumbItemGenerator(
                            gamePeriodTitle,
                            ""
                        )
                    ]}/>
                    <RaikoButtonSecondary label={"بازگشت"} onClick={_ => {
                        navigate(-1)
                    }}/>
                </RaikoFlexFirstChildGrowOne>

                <TabContext value={tabSelectedValue}>
                    <Box sx={{borderBottom: 1, borderColor: 'divider'}} className={css`overflow-x: hidden`}>
                        <TabList onChange={handleChangeTab} id="default-tab-container" variant="scrollable">
                            <Tab
                                label={GamePeriodTabType.BasicInformation.title}
                                value={GamePeriodTabType.BasicInformation.id}/>
                            <Tab
                                label={GamePeriodTabType.RequestsList.title}
                                value={GamePeriodTabType.RequestsList.id}/>
                            <Tab
                                label={GamePeriodTabType.PlayerList.title}
                                value={GamePeriodTabType.PlayerList.id}/>
                            <Tab
                                label={GamePeriodTabType.TeamList.title}
                                value={GamePeriodTabType.TeamList.id}/>
                            <Tab
                                label={GamePeriodTabType.Results.title}
                                value={GamePeriodTabType.Results.id}/>
                        </TabList>

                    </Box>
                    <TabPanel value={GamePeriodTabType.BasicInformation.id}>
                        <GamePeriodBasicInfo gamePeriodId={gamePeriodId}/>
                    </TabPanel>
                    <TabPanel value={GamePeriodTabType.RequestsList.id}>
                        <GameRegistration gamePeriodId={gamePeriodId} gamePeriodTitle={gamePeriodTitle}/>
                    </TabPanel>
                    <TabPanel value={GamePeriodTabType.PlayerList.id}>
                        بازیکنان
                    </TabPanel>
                    <TabPanel value={GamePeriodTabType.TeamList.id}>
                        <GameTeams gamePeriodId={gamePeriodId} gamePeriodTitle={gamePeriodTitle}/>
                    </TabPanel>
                    <TabPanel value={GamePeriodTabType.Results.id}>
                        نتایج
                    </TabPanel>
                </TabContext>
            </RaikoGridOneColumn>
        </RaikoBaseContainer>
    )
}
const GamePeriodTabType = {
    BasicInformation: {
        id: "basic-information",
        title: "اطلاعات پایه",
    },
    RequestsList: {
        id: "Registrants",
        title: "ثبت نام"
    },
    PlayerList: {
        id: "player-list",
        title: "بازیکنان"
    },
    TeamList: {
        id: "team-list",
        title: "تیم ها"
    },
    Results: {
        id: "results",
        title: "نتایج"
    }
}